import type { PersonInvolvementKind } from "../types/involvement.js";
import {
  OrganisationTypeSchema,
  type OrganisationType,
} from "../types/organisation.js";
import { isOrganisationTypeEligibleFor } from "./isOrganisationTypeEligibleFor.js";

/**
 * The kinds of organisation that may hold an involvement of this kind, for a
 * picker to offer.
 */
export const organisationTypesEligibleFor = (
  kind: PersonInvolvementKind,
): OrganisationType[] =>
  OrganisationTypeSchema.options.filter((organisationType) =>
    isOrganisationTypeEligibleFor(organisationType, kind),
  );
